import { useCallback, useEffect } from 'react';

const useDebounce = (effect, delay, deps) => {
	// eslint-disable-next-line react-hooks/exhaustive-deps -- deps are passed by caller
	const callback = useCallback(effect, deps);

	useEffect(() => {
		const handler = setTimeout(() => {
			callback();
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [callback, delay]);
};

export default useDebounce;
